import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ENV } from "config/config";
import { useVerifyRoleQuery } from "./redux/api";
var CryptoJS = require("crypto-js");

const Getter = () => {
  const history = useHistory();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";

  const { error } = useVerifyRoleQuery(roleDecrypted, {
    skip: !roleEncrypted,
  });

  useEffect(() => {
    if (!localStorage.getItem("userID")) {
      localStorage.clear();
      history.push("/login");
    }
  }, [history]);

  useEffect(() => {
    if (error) {
      localStorage.clear();
      history.push("/login");
    }
  }, [error, history]);

  return <></>;
};

export default Getter;
